//------------------------------------------------------------------------
// Responsive video source support (used by homepage hero)
//
// Markup example:
//
//  <video class="HomeHero-video no-js-hide" preload="none" loop muted playsinline data-autoplay>
//    <source type="video/webm" data-src="{{ $desktop_video['webm'] }}" data-media="(min-width: 768px)">
//    <source type="video/mp4" data-src="{{ $desktop_video['mp4'] }}" data-media="(min-width: 768px)">
//    <source type="video/webm" data-src="{{ $mobile_video['webm'] }}" data-media="(max-width: 768px)">
//    <source type="video/mp4" data-src="{{ $mobile_video['mp4'] }}" data-media="(max-width: 768px)">
//  </video>
//
// Note: JS is required to swap video sources since <source> doesn’t support the “media” attribute
// https://stackoverflow.com/questions/25907930/chrome-not-respecting-video-source-inline-media-queries
//------------------------------------------------------------------------
export default class ResponsiveVideo {
  constructor() {
    this.video = document.querySelector('.js-responsive-video');

    if (!this.video) {
      return;
    }

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.shouldAutoPlay = !this.prefersReducedMotion && this.video.hasAttribute('data-autoplay');
    this.videoLoadEvt = new CustomEvent('video-loaded');

    // Get <source> elements
    this.sources = this.video.querySelectorAll('source[data-media][data-src]');

    if (!this.sources.length) {
      console.warn(`Unable to find video sources within “${selector}”`);
      return false;
    }

    // Setup sources
    this.sources.forEach((source) => {
      this.setupSources(source);
    });

    // Add autoplay support
    // Note: “canplay” is fired even if video may need to buffer
    //       “canplaythrough” is fired when enough data has loaded to avoid buffering
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canplay_event
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canplaythrough_event
    if (this.shouldAutoPlay) {
      this.video.addEventListener('canplaythrough', () => {
        this.video.play();
        // Tell video toggle button to update its state
        document.documentElement.dispatchEvent(this.videoLoadEvt);
      });
    }
  }

  setupSources(el) {
    let src = el.getAttribute('data-src');
    let mediaQueryList = window.matchMedia(el.getAttribute('data-media'));

    // Listen for breakpoint change
    mediaQueryList.addListener(evt => {
      if (evt.matches) {
        el.setAttribute('src', src);
        this.video.load();// without this the browser won’t load the new source
      } else {
        el.removeAttribute('src');
      }
    });

    // Check on intial page load
    if (mediaQueryList.matches) {
      el.setAttribute('src', src);
      this.video.load();
    }
  }
}

// Init
new ResponsiveVideo();